import CommonInformationDetail from '../../../common/pages/secure/InformationDetail'
import Config from '../../../Config'

class InformationDetail extends CommonInformationDetail {
  constructor (props) {
    super(props)
    this.apiUrl = Config.companyAdminApiUrl.systemSettings
    this.userRoleUrl = 'company_admin'
    this.userRole = 'companyAdmin'
    this.isShowingEditButton = false
    this.isShowingDeleteButton = false
  }
}

export default InformationDetail



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/InformationDetail.js